import { render } from "./[alias].vue?vue&type=template&id=9516d5ba"
import script from "./[alias].vue?vue&type=script&lang=js"
export * from "./[alias].vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__